import { Engagement, Entity } from '../models';
import { ResourceConfig } from '@repo/core/resources';
import { HttpClient } from '@repo/core/api';

const http = new HttpClient({ baseURL: ResourceConfig.clientPortalServerBase });

export const useEntityService = () => {
  const get = async (parameters?: string): Promise<Entity[]> => {
    parameters = parameters || '';

    try {
      const response = await http.get('entities?$filter=clientPortalEnabled eq true' + parameters);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const current = async (): Promise<Entity> => {
    try {
      const response = await http.get(`entities/current?$expand=*`);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const engagements = async (): Promise<Engagement[]> => {
    try {
      const response = await http.get(`entities/engagements`);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const post = async (data: Entity[], options?: any): Promise<Entity[]> => {
    if (!options) options = {};
    options.autoSave = options.autoSave != null ? options.autoSave : true;

    try {
      const response = await http.post(`entities`, data, { headers: options });
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    get,
    current,
    post,
    engagements
  };
};
